import { toast } from "sonner";
import IconButton from "../IconButton/IconButton";
import Text from "../Text/Text";
import { cn } from "../../cn";
import ErrorIcon from "./ErrorIcon";
import SuccessIcon from "./SuccessIcon";

export function createToast(e: string | React.ReactNode, isError = false) {
  toast.custom((t) => (
    <div
      className={cn(
        "relative overflow-hidden bg-white shadow-y-plus-4 rounded-1 w-80 h-16 flex items-center px-3 before:absolute before:top-0 before:left-0 before:h-full before:w-1",
        isError ? "before:bg-red" : "before:bg-green",
      )}
    >
      {isError ? <ErrorIcon /> : <SuccessIcon />}
      <div className="flex-1 flex flex-col mx-4">
        <Text
          variant="body-4"
          weight="medium"
          className="text-grey-6 leading-5"
        >
          {e}
        </Text>
      </div>
      <IconButton
        icon="close"
        variant="square"
        color="transparent"
        className="size-3"
        onPress={() => toast.dismiss(t)}
      />
    </div>
  ));
}
